import { isEmptyArray } from "formik";
import { startCase, toLower } from "lodash";
import React, { useState } from "react";
import { LoaderWrapper } from "../";
import { useDeepEffect } from "../../abstracts";
import AddToolTip from "../AddToolTip";

const PayrollMultiSelectDropDown = ({
  label,
  options,
  setTransformedValues,
  transformedValues,
  value,
  name,
  onSelect,
  isLoading,
  height,
  width,
  maxHeight,
  zIndex,
  background,
  overflow,
  position,
}) => {
  const totalSelected = transformedValues.filter((_) => _.checked).length;
  const isAllSelected = totalSelected === transformedValues.length;
  const [selectAll, setSelectAll] = useState(isAllSelected ? true : false);
  // useDeepEffect(() => {
  //   if (transformedValues[0]?.checked) {
  //     setSelectedOptions(transformedValues);
  //     setTransformedValues(
  //       transformedValues.map((_) => {
  //         return (_ = { ..._, checked: true });
  //       })
  //     );
  //     transformedValues.map((item, index) => value.push(index));
  //   }
  // }, [value, transformedValues]);
  // const onValueChange = (selectedItem) => {
  //   const totalChecked = [];
  //   setTransformedValues(
  //     transformedValues.map((item) => {
  //       const checked =
  //         selectedItem.value === item.value ? !item.checked : item.checked;
  //       if (checked) {
  //         totalChecked.push(item);
  //       }
  //       return {
  //         ...item,
  //         checked,
  //       };
  //     })
  //   );
  //   onSelect(totalChecked.map(({ value }) => value));
  //   setSelectedOptions(totalChecked);
  // };

  // useDeepEffect(() => {
  //   if (selectAll) {
  //     setSelectedOptions(transformedValues);
  //     setTransformedValues(
  //       transformedValues.map((_) => {
  //         return (_ = { ..._, checked: true });
  //       })
  //     );
  //     transformedValues.map((item, index) => value.push(index));
  //   } else {
  //     setTransformedValues(
  //       transformedValues.map((_) => {
  //         return (_ = { ..._, checked: false });
  //       })
  //     );
  //   }
  // }, [selectAll]);
  const onSelectAllClick = () => {
    if (!selectAll) {
      var temOptions = transformedValues.map((item, ind) => {
        return { ...item, checked: true };
      });
      setTransformedValues(temOptions);
      onSelect(temOptions.filter((_) => _.checked).map((item) => item.value));
    } else {
      var temOptions = transformedValues.map((item, ind) => {
        return { ...item, checked: false };
      });
      setTransformedValues(temOptions);
      onSelect(temOptions.filter((_) => _.checked).map((item) => item.value));
    }
    //   const allSelectedOptions =
    //     transformedValues[0]?.checked == true ? [] : options;
    //   // setSelectedOptions(allSelectedOptions);
    //   // isArrayOfObjects && isSelectAllClick(allSelectedOptions);
    //   // onSelect(allSelectedOptions.map(({ value }) => value));
  };

  const onOptionClick = (value, index) => {
    var temOptions = transformedValues.map((item, ind) => {
      if (ind == index) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });
    setSelectAll(temOptions.every((_) => _.checked));
    setTransformedValues(temOptions);
    onSelect(temOptions.filter((_) => _.checked).map((item) => item.value));
  };
  const rowItemFocus = (e, isFocus) => {
    const targetElement = e.target.parentElement;
    if (targetElement) {
      const classNames = targetElement.getAttribute("class");
      if (isFocus) {
        targetElement.setAttribute("class", `${classNames} focus`);
      } else {
        targetElement.setAttribute("class", classNames.replace(" focus", ""));
      }
    }
  };

  return (
    <div
      className={"multiselect-dropdown-wrapper"}
      style={{
        height,
        width,
        maxHeight,
        zIndex,
        background,
        position,
        padding: "15px",
      }}
    >
      <LoaderWrapper isLoading={isLoading}>
        <div className="w-100 h-100 dropdown-items">
          <div>
            <div
              className={"mb-2 mt-2"}
              style={{ display: "flex", height: "45px", width: "250px" }}
            >
              <div
                className="file-status-dropdown-name"
                style={{
                  width: "250px",
                  paddingTop: "7px",
                  paddingLeft: "10px",
                }}
              >
                All Status
              </div>
              <input
                custom
                name={name}
                type="checkbox"
                onClick={() => {
                  setSelectAll(!selectAll);
                  onSelectAllClick();
                }}
                checked={selectAll}
                onFocus={(e) => rowItemFocus(e, true)}
                onBlur={(e) => rowItemFocus(e, false)}
                style={{ cursor: "pointer" }}
              />
            </div>
            <hr
              style={{
                margin: "0px",
              }}
            ></hr>
          </div>
          <>
            {transformedValues.map((item, index) => {
              return (
                <div>
                  <div
                    className={`mb-2 mt-2 border${startCase(
                      toLower(item.label)
                    ).replaceAll(" ", "")}`}
                    style={{ display: "flex", height: "45px", width: "250px" }}
                  >
                    <div
                      className="file-status-dropdown-name"
                      style={{
                        width: "250px",
                        paddingTop: "7px",
                        paddingLeft: "10px",
                      }}
                    >
                      {item.label}
                    </div>
                    <input
                      custom
                      name={name}
                      type="checkbox"
                      onClick={() => {
                        onOptionClick(item, index);
                      }}
                      label={
                        item.label && item.label.length > 25 && overflow ? (
                          <AddToolTip name={item.label}>
                            {item.label.slice(0, 25)}...
                          </AddToolTip>
                        ) : (
                          item.label
                        )
                      }
                      checked={item.checked}
                      // onFocus={(e) => rowItemFocus(e, true)}
                      // onBlur={(e) => rowItemFocus(e, false)}
                      id={`custom-radio-${name}-${item.value}`}
                      key={`custom-radio-${name}-${item.value}`}
                      style={{ cursor: "pointer" }}
                      // onChange={() => onValueChange(item)}
                    />
                  </div>
                  <hr
                    style={{
                      margin: "0px",
                    }}
                  ></hr>
                </div>
              );
            })}
          </>
        </div>
      </LoaderWrapper>
    </div>
  );
};

PayrollMultiSelectDropDown.defaultProps = {
  options: [],
  value: [],
  hideSelectedOptions: true,
};
export default PayrollMultiSelectDropDown;
